import { Bank } from "./bank.model";
import { DisbursementConfig } from "./disbursementConfig.model";
import { Partner } from "./partner.model";
import { Obj } from "./types";

export class Merchant {
  id?: number;
  alias_id?: string;
  business_name?: string;
  trading_name?: string;
  property_address?: string;
  use_property_address?: number;
  organization_address?: string;
  country?: string;
  timezone?: string;
  created_at?: number;
  updated_at?: number;
  status?: number;
  no?: number;
  partners?: Partner[];
  banks?: Bank;
  disbursement_config?: DisbursementConfig;

  constructor({
    id,
    alias_id,
    business_name,
    trading_name,
    property_address,
    use_property_address,
    organization_address,
    country,
    timezone,
    created_at,
    updated_at,
    status,
    no,
    partners,
    disbursement_config,
  }: Obj) {
    if (id !== undefined) this.id = id;
    if (alias_id !== undefined) this.alias_id = alias_id;
    if (business_name !== undefined) this.business_name = business_name;
    if (trading_name !== undefined) this.trading_name = trading_name;
    if (property_address !== undefined) this.property_address = property_address;
    if (use_property_address !== undefined) this.use_property_address = use_property_address;
    if (organization_address !== undefined) this.organization_address = organization_address;
    if (country !== undefined) this.country = country;
    if (timezone !== undefined) this.timezone = timezone;
    if (created_at !== undefined) this.created_at = created_at;
    if (updated_at !== undefined) this.updated_at = updated_at;
    if (status !== undefined) this.status = status;
    if (no !== undefined) this.no = no;
    if(partners !== undefined) this.partners = partners
    if(disbursement_config !== undefined) this.disbursement_config = new DisbursementConfig({}).fromPayload(disbursement_config)
  }

  fromPayload({
    id,
    business_name,
    trading_name,
    property_address,
    use_property_address,
    organization_address,
    country,
    timezone,
    created_at,
    updated_at,
    status,
    no,
    partners,
    disbursement_config
  }: Obj): this {
    if (id !== undefined) this.id = id;
    if (business_name !== undefined) this.business_name = business_name;
    if (trading_name !== undefined) this.trading_name = trading_name;
    if (property_address !== undefined) this.property_address = property_address;
    if (use_property_address !== undefined) this.use_property_address = use_property_address;
    if (organization_address !== undefined) this.organization_address = organization_address;
    if (country !== undefined) this.country = country;
    if (timezone !== undefined) this.timezone = timezone;
    if (created_at !== undefined) this.created_at = created_at;
    if (updated_at !== undefined) this.updated_at = updated_at;
    if (status !== undefined) this.status = status;
    if (no !== undefined) this.no = no;
    if(partners !== undefined) this.partners = partners;
    if(disbursement_config !== undefined) this.disbursement_config = new DisbursementConfig({}).fromPayload(disbursement_config)
    return this;
  }
}
